import React from "react";
import { Button } from "semantic-ui-react";
import { UsernameInput, EmailInput } from "../../components";

import ValidationContext from "../../formvalidation/FormContext";
import FirstNameInput from "../../components/ValidatedFields/WithErrorLabel/FirstNameInput";
import LastNameInput from "../../components/ValidatedFields/WithErrorLabel/LastNameInput";
import EditViewPanel from "components/panels/EditViewPanel";
import { useValidators } from "formvalidation/hooks";
import CulturesInterfaceDropdown from "components/dropdowns/reactselect/CulturesInterfaceDropdown";

interface Props {
  UpgradeMessage?: string
  redirectUrlWithKey: string
  environment: server.dto.Environments
  title: string
}

const UserInvitationPanel = (props: Props) => {
  const [firstName, setFirstName] = React.useState<string>("");
  const [lastName, setLastName] = React.useState<string>("");
  const [locale, setLocale] = React.useState(serverReference.interfaceCultures.find(c => c.locale === site.culture.uiLocale));
  const [email, setEmail] = React.useState<string>("");
  const [username, setUsername] = React.useState<string>("");

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const validators = useValidators();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) {
      return;
    }

    setIsLoading(true);
    const validationResult = await validators.validateAll();
    if (validationResult.hasErrors) {
      setIsLoading(false);
      return;
    }

    const result = await window.CoreApi.User.InviteUser(props.environment, {
      firstName,
      lastName,
      email,
      username,
      locale: locale.locale
    });

    window.location.href = props.redirectUrlWithKey.replace("{key}", result.data.data.userToClientId.toString());
  };

  return <EditViewPanel
    title={props.title}
  >
    <ValidationContext settings={validators.validatorSettings}>
      <table className="s1_table clean rowspace">
        <tbody>
          <tr>
            <td>{RESX.GeneralLabels.Name}</td>
            <td className="flex">
              <div className="grow1 margin-right">
                <FirstNameInput
                  placeholder={RESX.Contact.FirstName}
                  value={firstName}
                  onChange={setFirstName}
                  validatorKey="firstName"
                />
              </div>
              <div className="grow1">
                <LastNameInput
                  placeholder={RESX.Contact.LastName}
                  value={lastName}
                  onChange={setLastName}
                  validatorKey="lastName"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>{RESX.Language.resxLanguage}</td>
            <td>
              <CulturesInterfaceDropdown
                value={locale}
                onChange={setLocale}
              />
            </td>
          </tr>
          <tr>
            <td>{RESX.GeneralLabels.Email}</td>
            <td>
              <EmailInput
                value={email}
                onChange={setEmail}
                validatorKey={"email"}
                emailCanBeBlank={false}
              />
            </td>
          </tr>
          <tr>
            <td>{RESX.SoUser.Username}</td>
            <td>
              {/* Text input.
                        Cannot be empty.
                        Should use the API to check if the username exists and otherwise suggest another, like we also do upon creating new account. */}
              <UsernameInput
                value={username}
                onChange={setUsername}
                validatorKey={"username"}
              />
            </td>
          </tr>
          <tr>
            <td>{RESX.PersonalSettings.Password}</td>
            <td className="s1_gray">
              {RESX.SoUser.WillBeAutomaticallyGenerated}
            </td>
          </tr>
        </tbody>
      </table>

      <div className="flex justify-end margin-top-bigger">
        <Button loading={isLoading} onClick={onSubmit} primary>{RESX.Buttons.btnSave}</Button>
      </div>
    </ValidationContext>
  </EditViewPanel>;
};

export default UserInvitationPanel;